import { render, staticRenderFns } from "./empresas.vue?vue&type=template&id=7acee827&scoped=true&"
import script from "./empresas.vue?vue&type=script&lang=js&"
export * from "./empresas.vue?vue&type=script&lang=js&"
import style0 from "./empresas.vue?vue&type=style&index=0&id=7acee827&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acee827",
  null
  
)

export default component.exports